function p(a) {
  return a.name.value;
}

function t(a) {
  return a.selectionSet ? a.selectionSet.selections : [];
}

function aa(a) {
  return (a = a.typeCondition) ? p(a) : null;
}

function ba(a, b) {
  var e, f, g, h, c = {}, d = 0;
  if (a.arguments && a.arguments.length) {
    for (e = 0, f = a.arguments.length; e < f; e++) {
      null != (h = valueFromASTUntyped((g = a.arguments[e]).value, b)) && (c[p(g)] = h, 
      d++);
    }
  }
  return 0 < d ? c : null;
}

function ca(a, b) {
  var d, e, f, g, h, c = {};
  if (!b) {
    return c;
  }
  if (a.variableDefinitions) {
    for (d = 0, e = a.variableDefinitions.length; d < e; d++) {
      c[g = p((f = a.variableDefinitions[d]).variable)] = void 0 === b[g] && f.defaultValue ? valueFromASTUntyped(f.defaultValue, b) : b[g];
    }
  }
  for (h in b) {
    h in c || (c[h] = b[h]);
  }
  return c;
}

function w(a, b) {
  var c = "";
  b.kind === Kind.INLINE_FRAGMENT ? c = a ? 'Inline Fragment on "' + a + '"' : "Inline Fragment" : b.kind === Kind.OPERATION_DEFINITION ? c = (b.name ? '"' + b.name.value + '"' : "Unnamed") + " " + b.operation : b.kind === Kind.FRAGMENT_DEFINITION && (c = '"' + b.name.value + '" Fragment');
  c && u.push(c);
}

function ea() {
  return u.length ? "\n(Caused At: " + u.join(", ") + ")" : "";
}

function x(a, b, c) {
  if (!a) {
    throw a = b || "Minfied Error #" + c + "\n", "production" !== process.env.NODE_ENV && (a += ea()), 
    (c = Error(a + "\nhttps://bit.ly/2XbVrpR#" + c)).name = "Graphcache Error", c;
  }
}

function z(a, b) {
  da.has(a) || (console.warn(a + ea() + "\nhttps://bit.ly/2XbVrpR#" + b), da.add(a));
}

function la(a) {
  return a.kind === Kind.FRAGMENT_DEFINITION;
}

function ma(a) {
  return a.kind === Kind.OPERATION_DEFINITION;
}

function B(a) {
  x(!!(a = a.definitions.find(ma)), "production" !== process.env.NODE_ENV ? "Invalid GraphQL document: All GraphQL documents must contain an OperationDefinitionnode for a query, subscription, or mutation." : "", 1);
  return a;
}

function na(a, b) {
  a[p(b)] = b;
  return a;
}

function C(a) {
  return a.definitions.filter(la).reduce(na, {});
}

function oa(a, b) {
  var d, e, f, c = a.directives;
  if (!c) {
    return !0;
  }
  for (d = 0, e = c.length; d < e; d++) {
    if (("include" === (a = p(f = c[d])) || "skip" === a) && f.arguments && f.arguments[0] && "if" === p(f.arguments[0])) {
      return b = valueFromASTUntyped(f.arguments[0].value, b), "include" === a ? !!b : !b;
    }
  }
  return !0;
}

function pa(a, b, c) {
  return !!(a = E(a, b, c)) && isNullableType(a.type);
}

function qa(a, b, c) {
  if (!(a = E(a, b, c))) {
    return !1;
  }
  a = isNonNullType(a.type) ? a.type.ofType : a.type;
  return isListType(a) && isNullableType(a.ofType);
}

function E(a, b, c) {
  ra(a = a.getType(b), b);
  a = a.getFields()[c];
  "production" !== process.env.NODE_ENV && (a || z("Invalid field: The field `" + c + "` does not exist on `" + b + "`, but the GraphQL document expects it to exist.\nTraversal will continue, however this may lead to undefined behavior!", 4));
  return a;
}

function ra(a, b) {
  x(a instanceof GraphQLObjectType, "production" !== process.env.NODE_ENV ? "Invalid Object type: The type `" + b + "` is not an object in the defined schema, but the GraphQL document is traversing it." : "", 3);
}

function H(a) {
  "production" !== process.env.NODE_ENV && z("Invalid resolver: `" + a + "` is not in the defined schema, but the `resolvers` option is referencing it.", 23);
}

function I(a, b) {
  return b ? a + "(" + stringifyVariables(b) + ")" : a;
}

function wa(a) {
  var b = a.indexOf("(");
  return -1 < b ? {
    fieldKey: a,
    fieldName: a.slice(0, b),
    arguments: JSON.parse(a.slice(b + 1, -1))
  } : {
    fieldKey: a,
    fieldName: a,
    arguments: null
  };
}

function xa(a, b) {
  return a.replace(/\./g, "%2e") + "." + b;
}

function ya(a) {
  var b = a.indexOf(".");
  return {
    entityKey: a.slice(0, b).replace(/%2e/g, "."),
    fieldKey: a = a.slice(b + 1)
  };
}

function J() {
  return Object.create(null);
}

function O(a, b, c, d) {
  za = a;
  K = b;
  L = J();
  N = !!d;
  "production" !== process.env.NODE_ENV && (u.length = 0);
  c ? d || 0 < b.optimisticOrder.length ? (d || b.commutativeKeys.has(c) ? d && b.commutativeKeys.delete(c) : R(b, c), 
  M = c, -1 === b.optimisticOrder.indexOf(c) && b.optimisticOrder.unshift(c), b.refLock[c] || (b.refLock[c] = J(), 
  b.links.optimistic[c] = new Map, b.records.optimistic[c] = new Map)) : (M = null, 
  Aa(b, c)) : M = null;
}

function S() {
  "production" !== process.env.NODE_ENV && Da();
  var b = K, c = M;
  N = !1;
  M = null;
  if (c && -1 < b.optimisticOrder.indexOf(c)) {
    for (c = b.optimisticOrder.length; 0 <= --c && b.refLock[b.optimisticOrder[c]] && b.commutativeKeys.has(b.optimisticOrder[c]); ) {
      Ea(b.optimisticOrder[c]);
    }
  }
  L = K = za = null;
  "production" !== process.env.NODE_ENV && (u.length = 0);
  "test" === process.env.NODE_ENV || b.defer || (b.defer = !0, Promise.resolve().then((function a() {
    O("write", b, null);
    K.gc.forEach(Ba);
    !function Ca() {
      if (K.storage) {
        N = !0;
        var b = J();
        K.persist.forEach((function a(a) {
          var f, c = ya(a), e = c.entityKey;
          void 0 !== (f = V(e, c = c.fieldKey)) ? b[a] = ":" + stringifyVariables(f) : void 0 !== (f = U(e, c)) ? b[a] = stringifyVariables(f) : b[a] = void 0;
        }));
        N = !1;
        K.storage.writeData(b);
        K.persist.clear();
      }
    }();
    S();
    b.defer = !1;
  })));
}

function Fa(a, b, c) {
  O("read", a, b, c);
  S();
}

function Da() {
  x(null !== L, "production" !== process.env.NODE_ENV ? "Invalid Cache call: The cache may only be accessed or mutated duringoperations like write or query, or as part of its resolvers, updaters, or optimistic configs." : "", 2);
  return L;
}

function Ga(a, b, c, d) {
  var e = (a = M ? a.optimistic[M] : a.base).get(b);
  void 0 === e && a.set(b, e = J());
  void 0 !== d || M ? e[c] = d : delete e[c];
}

function Ha(a, b, c) {
  var d, e, f, g, h;
  for (e = 0, f = K.optimisticOrder.length; e < f; e++) {
    if ((h = a.optimistic[g = K.optimisticOrder[e]]) && (!N || K.commutativeKeys.has(g)) && void 0 !== (d = h.get(b)) && c in d) {
      return d[c];
    }
  }
  return void 0 !== (d = a.base.get(b)) ? d[c] : void 0;
}

function Ia(a, b, c, d) {
  var e = void 0 !== b[c] ? b[c] : 0;
  b = b[c] = e + d | 0;
  void 0 !== a && (0 >= b ? a.add(c) : 0 >= e && 0 < b && a.delete(c));
}

function Ja(a, b, c, d) {
  var e, f, g;
  if ("string" == typeof c) {
    Ia(a, b, c, d);
  } else if (Array.isArray(c)) {
    for (e = 0, f = c.length; e < f; e++) {
      (g = c[e]) && Ia(a, b, g, d);
    }
  }
}

function Ka(a, b, c) {
  if (void 0 !== c) {
    for (var d in c) {
      b.has(d) || (a.push(wa(d)), b.add(d));
    }
  }
}

function La(a, b, c, d) {
  var e, f, g;
  Ka(a, b, d.base.get(c));
  for (e = 0, f = K.optimisticOrder.length; e < f; e++) {
    void 0 !== (g = d.optimistic[K.optimisticOrder[e]]) && Ka(a, b, g.get(c));
  }
}

function Ba(a, b, c) {
  var d, e;
  if (0 < (K.refCount[a] || 0)) {
    c.delete(a);
  } else {
    for (d in K.refLock) {
      if (0 < ((b = K.refLock[d])[a] || 0)) {
        return;
      }
      delete b[a];
    }
    delete K.refCount[a];
    c.delete(a);
    K.records.base.delete(a);
    if (d = K.links.base.get(a)) {
      K.links.base.delete(a);
      for (e in d) {
        Ja(c, K.refCount, d[e], -1);
      }
    }
  }
}

function T(a, b) {
  "__typename" !== b && (a !== K.queryRootKey ? L[a] = !0 : void 0 !== b && (L[a + "." + b] = !0));
}

function U(a, b) {
  T(a, b);
  return Ha(K.records, a, b);
}

function V(a, b) {
  T(a, b);
  return Ha(K.links, a, b);
}

function W(a, b, c) {
  T(a, b);
  !N && K.storage && K.persist.add(xa(a, b));
  Ga(K.records, a, b, c);
}

function Ma(a, b, c) {
  var e, f, g, d = K;
  if (M) {
    e = d.refLock[M] || (d.refLock[M] = J());
    f = d.links.optimistic[M];
  } else {
    e = d.refCount;
    f = d.links.base;
    g = d.gc;
  }
  f = (f = f && f.get(a)) && f[b];
  T(a, b);
  !N && K.storage && K.persist.add(xa(a, b));
  Ga(d.links, a, b, c);
  Ja(g, e, f, -1);
  Ja(g, e, c, 1);
}

function R(a, b) {
  var c = a.optimisticOrder.indexOf(b);
  -1 === c ? a.optimisticOrder.unshift(b) : a.commutativeKeys.has(b) || (Na(a, b), 
  a.optimisticOrder.splice(c, 1), a.optimisticOrder.unshift(b));
  a.commutativeKeys.add(b);
}

function Na(a, b) {
  a.refLock[b] && (delete a.refLock[b], delete a.records.optimistic[b], delete a.links.optimistic[b]);
}

function Aa(a, b) {
  var c = a.optimisticOrder.indexOf(b);
  -1 < c && (a.optimisticOrder.splice(c, 1), a.commutativeKeys.delete(b));
  Na(a, b);
}

function Oa(a, b) {
  for (var c in a) {
    Ma(b, c, a[c]);
  }
}

function Pa(a, b) {
  for (var c in a) {
    W(b, c, a[c]);
  }
}

function Ea(a) {
  var c, b = L;
  L = J();
  (c = K.links.optimistic[a]) && c.forEach(Oa);
  (c = K.records.optimistic[a]) && c.forEach(Pa);
  L = b;
  Aa(K, a);
}

function Qa(a) {
  var b = K.links, c = K.records, d = [], e = new Set;
  T(a);
  La(d, e, a, b);
  La(d, e, a, c);
  return d;
}

function X(a, b, c, d, e, f) {
  return {
    store: a,
    variables: b,
    fragments: c,
    parentTypeName: d,
    parentKey: e,
    parentFieldKey: "",
    fieldName: "",
    partial: !1,
    optimistic: !!f
  };
}

function Ra(a, b, c, d) {
  if (!b) {
    return !1;
  }
  var e = aa(a);
  if (b === e) {
    return !0;
  }
  "production" !== process.env.NODE_ENV && z("Heuristic Fragment Matching: A fragment is trying to match against the `" + b + "` type, but the type condition is `" + e + "`. Since GraphQL allows for interfaces `" + e + "` may be aninterface.\nA schema needs to be defined for this match to be deterministic, otherwise the fragment will be matched heuristically!", 16);
  return !t(a).some((function(a) {
    if (a.kind !== Kind.FIELD) {
      return !1;
    }
    a = I(p(a), ba(a, d));
    return !(void 0 !== U(c, a) || void 0 !== V(c, a));
  }));
}

function Sa(a, b, c, d) {
  var e = [ 0 ], f = [ c ];
  return {
    next: function() {
      var c, h, k, l, n, m;
      for (;0 !== e.length; ) {
        if ((c = e[e.length - 1]++) >= (h = f[f.length - 1]).length) {
          e.pop(), f.pop(), "production" !== process.env.NODE_ENV && u.pop();
        } else if (oa(c = h[c], d.variables)) {
          if (c.kind === Kind.FIELD) {
            if ("__typename" !== p(c)) {
              return c;
            }
          } else if (void 0 !== (c = c.kind === Kind.INLINE_FRAGMENT ? c : d.fragments[p(c)])) {
            "production" !== process.env.NODE_ENV && w(a, c);
            if (d.store.schema) {
              h = d.store.schema;
              k = aa(c);
              if ((l = a) && k) {
                if (l === k) {
                  h = !0;
                } else {
                  n = h.getType(k), m = h.getType(l);
                  n instanceof GraphQLObjectType ? h = n === m : (x(n instanceof GraphQLInterfaceType || n instanceof GraphQLUnionType, "production" !== process.env.NODE_ENV ? "Invalid Abstract type: The type `" + k + "` is not an Interface or Union type in the defined schema, but a fragment in the GraphQL document is using it as a type condition." : "", 5), 
                  ra(m, l), h = h.isPossibleType(n, m));
                }
              } else {
                h = !1;
              }
            } else {
              h = Ra(c, a, b, d.variables);
            }
            h && (e.push(0), f.push(t(c)));
          }
        }
      }
    }
  };
}

function Ta(a) {
  return void 0 === a ? null : a;
}

function Ua(a, b, c, d) {
  O("write", a.data, d || null);
  a = Va(a, b, c);
  S();
  return a;
}

function Va(a, b, c) {
  var d = B(b.query), e = {
    data: c,
    dependencies: Da()
  }, f = a.rootFields[d.operation];
  a = X(a, ca(d, b.variables), C(b.query), f, f);
  "production" !== process.env.NODE_ENV && w(f, d);
  Wa(a, f, t(d), c);
  "production" !== process.env.NODE_ENV && u.pop();
  return e;
}

function Xa(a, b, c) {
  O("write", a.data, c, !0);
  c = B(b.query);
  var d = {
    data: {},
    dependencies: Da()
  }, e = a.rootFields[c.operation];
  x(e === a.rootFields.mutation, "production" !== process.env.NODE_ENV ? "writeOptimistic(...) was called with an operation that is not a mutation.\nThis case is unsupported and should never occur." : "", 10);
  "production" !== process.env.NODE_ENV && w(e, c);
  Wa(a = X(a, ca(c, b.variables), C(b.query), e, e, !0), e, t(c), d.data);
  "production" !== process.env.NODE_ENV && u.pop();
  S();
  return d;
}

function Wa(a, b, c, d) {
  var h, k, l, n, m, q, v, y, D, e = b === a.store.rootFields.query, f = !e && !!a.store.rootNames[b], g = f || e ? b : d.__typename;
  if (g) {
    f || e || !b || W(b, "__typename", g);
    c = Sa(g, b || g, c, a);
    for (;h = c.next(); ) {
      l = I(e = p(h), k = ba(h, a.variables)), m = d[n = h.alias ? h.alias.value : p(h)];
      if ("production" !== process.env.NODE_ENV) {
        if (f || void 0 !== m) {
          a.store.schema && g && E(a.store.schema, g, e);
        } else {
          e = a.optimistic ? "\nYour optimistic result may be missing a field!" : "";
          k = void 0 === h.selectionSet ? "scalar (number, boolean, etc)" : "selection set";
          "production" !== process.env.NODE_ENV && z("Invalid undefined: The field at `" + l + "` is `undefined`, but the GraphQL query expects a " + k + " for this field." + e, 13);
          continue;
        }
      }
      if (a.optimistic && f) {
        if (!(m = a.store.optimisticMutations[e])) {
          continue;
        }
        v = g, y = l, D = e;
        (q = a).parentTypeName = g;
        q.parentKey = v;
        q.parentFieldKey = y;
        q.fieldName = D;
        m = d[n] = Ta(m(k || {}, a.store, a));
      }
      h.selectionSet ? b && !f ? (n = b + "." + l, Ma(b || g, l, h = Ya(a, t(h), Ta(m), n))) : Ya(a, t(h), Ta(m)) : b && !f && W(b || g, l, m);
      f && (n = g, l = g + "." + l, q = e, (h = a).parentTypeName = g, h.parentKey = n, 
      h.parentFieldKey = l, h.fieldName = q, l = a.store.updates[g][e]) && (d[e] = m, 
      l(d, k || {}, a.store, a));
    }
  }
}

function Ya(a, b, c, d) {
  var e, f, g, h;
  if (Array.isArray(c)) {
    for (e = Array(c.length), f = 0, g = c.length; f < g; f++) {
      h = Ya(a, b, c[f], d ? d + "." + f : void 0);
      e[f] = h;
    }
    return e;
  }
  if (null === c) {
    return null;
  }
  e = a.store.keyOfEntity(c);
  f = c.__typename;
  "production" !== process.env.NODE_ENV && d && void 0 === a.store.keys[c.__typename] && null === e && "string" == typeof f && !Za.test(f) && z("Invalid key: The GraphQL query at the field at `" + d + "` has a selection set, but no key could be generated for the data at this field.\nYou have to request `id` or `_id` fields for all selection sets or create a custom `keys` config for `" + f + "`.\nEntities without keys will be embedded directly on the parent entity. If this is intentional, create a `keys` config for `" + f + "` that always returns null.", 15);
  Wa(a, d = e || d, b, c);
  return d || null;
}

function Y(a) {
  var b, c, d, e, f, g, h, k, l, n, m, q, v;
  this.keyOfField = I;
  a || (a = {});
  this.resolvers = a.resolvers || {};
  this.optimisticMutations = a.optimistic || {};
  this.keys = a.keys || {};
  this.updates = {
    Mutation: a.updates && a.updates.Mutation || {},
    Subscription: a.updates && a.updates.Subscription || {}
  };
  c = "Query", d = "Mutation", e = "Subscription";
  if (a.schema) {
    a = (f = this.schema = buildClientSchema(a.schema)).getQueryType();
    g = f.getMutationType();
    f = f.getSubscriptionType();
    a && (c = a.name);
    g && (d = g.name);
    f && (e = f.name);
    if ("production" !== process.env.NODE_ENV) {
      this.keys && function sa(a, b) {
        if ("production" !== process.env.NODE_ENV) {
          var d = Object.keys(a.getTypeMap());
          Object.keys(b).forEach((function c(a) {
            "production" !== process.env.NODE_ENV && -1 === d.indexOf(a) && z("Invalid Object type: The type `" + a + "` is not an object in the defined schema, but the `keys` option is referencing it.", 20);
          }));
        }
      }(this.schema, this.keys);
      if (0 < Object.keys(this.updates.Mutation).length || 0 < Object.keys(this.updates.Subscription).length) {
        if (a = this.schema, f = this.updates, "production" !== process.env.NODE_ENV) {
          g = a.getMutationType() ? Object.keys(a.getMutationType().toConfig().fields) : [];
          a = a.getSubscriptionType() ? Object.keys(a.getSubscriptionType().toConfig().fields) : [];
          h = f.Mutation ? Object.keys(f.Mutation) : [];
          f = f.Subscription ? Object.keys(f.Subscription) : [];
          for (k = 0; k < h.length; k += 1) {
            l = h[k];
            "production" !== process.env.NODE_ENV && -1 === g.indexOf(l) && z("Invalid mutation field: `" + l + "` is not in the defined schema, but the `updates.Mutation` option is referencing it.", 21);
          }
          for (g = 0; g < f.length; g += 1) {
            h = f[g], "production" !== process.env.NODE_ENV && -1 === a.indexOf(h) && z("Invalid subscription field: `" + h + "` is not in the defined schema, but the `updates.Subscription` option is referencing it.", 22);
          }
        }
      }
      if (this.resolvers && (a = this.schema, g = this.resolvers, "production" !== process.env.NODE_ENV)) {
        f = Object.keys(a.getTypeMap());
        for (n in g) {
          if ("Query" === n) {
            if (h = a.getQueryType()) {
              h = Object.keys(h.toConfig().fields);
              for (m in g.Query) {
                -1 === h.indexOf(m) && H("Query." + m);
              }
            } else {
              H("Query");
            }
          } else if (-1 === f.indexOf(n)) {
            H(n);
          } else {
            for (h = Object.keys(a.getType(n).getFields()), k = 0, l = Object.keys(g[n]); k < l.length; k += 1) {
              -1 === h.indexOf(q = l[k]) && H(n + "." + q);
            }
          }
        }
      }
      if (this.optimisticMutations && (m = this.schema, n = this.optimisticMutations, 
      "production" !== process.env.NODE_ENV)) {
        m = m.getMutationType() ? Object.keys(m.getMutationType().toConfig().fields) : [];
        for (v in n) {
          "production" !== process.env.NODE_ENV && -1 === m.indexOf(v) && z("Invalid optimistic mutation field: `" + v + "` is not a mutation field in the defined schema, but the `optimistic` option is referencing it.", 24);
        }
      }
    }
  }
  this.rootFields = {
    query: c,
    mutation: d,
    subscription: e
  };
  this.rootNames = ((b = {})[c] = "query", b[d] = "mutation", b[e] = "subscription", 
  b);
  b = c;
  this.data = {
    defer: !1,
    gc: new Set,
    persist: new Set,
    queryRootKey: b,
    refCount: J(),
    refLock: J(),
    links: {
      optimistic: J(),
      base: new Map
    },
    records: {
      optimistic: J(),
      base: new Map
    },
    commutativeKeys: new Set,
    optimisticOrder: [],
    storage: null
  };
}

function ab(a, b, c) {
  O("read", a.data, null);
  a = $a(a, b, c);
  S();
  return a;
}

function $a(a, b, c) {
  var d = B(b.query), e = a.rootFields[d.operation], f = t(d);
  a = X(a, ca(d, b.variables), C(b.query), e, e);
  "production" !== process.env.NODE_ENV && w(e, d);
  c = c || {};
  c = e !== a.store.rootFields.query ? bb(a, e, f, c) : Z(a, e, f, c);
  "production" !== process.env.NODE_ENV && u.pop();
  return {
    dependencies: Da(),
    partial: void 0 === c ? !1 : a.partial,
    data: void 0 === c ? null : c
  };
}

function bb(a, b, c, d) {
  var e, f, g;
  if ("string" != typeof d.__typename) {
    return d;
  }
  b = Sa(b, b, c, a);
  (c = {}).__typename = d.__typename;
  for (;void 0 !== (e = b.next()); ) {
    g = d[f = e.alias ? e.alias.value : p(e)];
    void 0 !== e.selectionSet && null !== g ? (g = Ta(g), c[f] = cb(a, t(e), g)) : c[f] = g;
  }
  return c;
}

function cb(a, b, c) {
  if (Array.isArray(c)) {
    for (var d = Array(c.length), e = 0, f = c.length; e < f; e++) {
      d[e] = cb(a, b, c[e]);
    }
    return d;
  }
  if (null === c) {
    return null;
  }
  return null !== (d = a.store.keyOfEntity(c)) ? void 0 === (a = Z(a, d, b, {})) ? null : a : bb(a, c.__typename, b, c);
}

function Z(a, b, c, d, e) {
  var k, l, n, m, q, v, y, D, F, G, P, r, A, f = a.store, g = b === f.rootFields.query, h = e && f.keyOfEntity(e) || b;
  "production" !== process.env.NODE_ENV && !g && a.store.rootNames[h] && z("Invalid root traversal: A selection was being read on `" + h + "` which is an uncached root type.\nThe `" + a.store.rootFields.mutation + "` and `" + a.store.rootFields.subscription + "` types are special Operation Root Types and cannot be read back from the cache.", 25);
  if ("string" == typeof (b = g ? b : U(h, "__typename") || e && e.__typename)) {
    if (e && b !== e.__typename) {
      "production" !== process.env.NODE_ENV && z("Invalid resolver data: The resolver at `" + h + "` returned an invalid typename that could not be reconciled with the cache.", 8);
    } else {
      d.__typename = b;
      c = Sa(b, h, c, a);
      for (l = !1, n = !1; void 0 !== (k = c.next()); ) {
        m = p(k), q = ba(k, a.variables), v = k.alias ? k.alias.value : p(k), D = h + "." + (y = I(m, q)), 
        F = U(h, y), G = e ? e[m] : void 0, P = f.resolvers[b];
        "production" !== process.env.NODE_ENV && f.schema && b && E(f.schema, b, m);
        r = void 0;
        if (void 0 !== G && void 0 === k.selectionSet) {
          r = G;
        } else if (x(null !== za, "production" !== process.env.NODE_ENV ? "Invalid Cache call: The cache may only be accessed or mutated duringoperations like write or query, or as part of its resolvers, updaters, or optimistic configs." : "", 2), 
        "read" === za && P && "function" == typeof P[m]) {
          y = h;
          G = D;
          A = m;
          (r = a).parentTypeName = b;
          r.parentKey = y;
          r.parentFieldKey = G;
          r.fieldName = A;
          void 0 !== F && (d[v] = F);
          r = P[m](d, q || {}, f, a);
          void 0 !== k.selectionSet && (r = db(a, b, m, D, t(k), d[v] || {}, r));
          if (f.schema && null === r && !pa(f.schema, b, m)) {
            return;
          }
        } else {
          void 0 === k.selectionSet ? r = F : void 0 !== G ? r = db(a, b, m, D, t(k), d[v], G) : void 0 !== (q = V(h, y)) ? r = eb(a, q, b, m, t(k), d[v]) : "object" == typeof F && null !== F && (r = F);
        }
        if (void 0 === r && f.schema && pa(f.schema, b, m)) {
          n = !0, d[v] = null;
        } else {
          if (void 0 === r) {
            return;
          }
          l = !0;
          d[v] = r;
        }
      }
      n && (a.partial = !0);
      return g && n && !l ? void 0 : d;
    }
  }
}

function db(a, b, c, d, e, f, g) {
  var h, k, l, n, m;
  if (Array.isArray(g)) {
    h = !(h = a.store).schema || qa(h.schema, b, c);
    for (k = Array(g.length), l = 0, n = g.length; l < n; l++) {
      if (void 0 !== (m = db(a, b, c, d + "." + l, e, null != f ? f[l] : void 0, g[l])) || h) {
        k[l] = void 0 !== m ? m : null;
      } else {
        return;
      }
    }
    return k;
  }
  if (null == g) {
    return g;
  }
  if (null === f) {
    return null;
  }
  if ("string" == typeof g || "object" == typeof g && "string" == typeof g.__typename) {
    return b = f || {}, "string" == typeof g ? Z(a, g, e, b) : Z(a, d, e, b, g);
  }
  "production" !== process.env.NODE_ENV && z("Invalid resolver value: The field at `" + d + "` is a scalar (number, boolean, etc), but the GraphQL query expects a selection set for this field.", 9);
}

function eb(a, b, c, d, e, f) {
  var g, h, k, l, n;
  if (Array.isArray(b)) {
    g = (g = a.store).schema && qa(g.schema, c, d);
    for (h = Array(b.length), k = 0, l = b.length; k < l; k++) {
      if (void 0 !== (n = eb(a, b[k], c, d, e, null != f ? f[k] : void 0)) || g) {
        h[k] = void 0 !== n ? n : null;
      } else {
        return;
      }
    }
    return h;
  }
  return null === b || null === f ? null : Z(a, b, e, f || {});
}

function fb(a, b) {
  return _extends({}, a, {
    context: _extends({}, a.context, {
      meta: _extends({}, a.context.meta, {
        cacheOutcome: b
      })
    })
  });
}

function gb(a, b) {
  return _extends({}, a, {
    context: _extends({}, a.context, {
      requestPolicy: b
    })
  });
}

function hb(a) {
  return "query" === a.operationName && "network-only" !== a.context.requestPolicy;
}

function ib(a) {
  return "query" !== a.operationName || "network-only" === a.context.requestPolicy;
}

function jb(a) {
  return "miss" !== a.outcome || "cache-only" === a.operation.context.requestPolicy;
}

function kb(a) {
  return function(b) {
    function c(a, b) {
      var ta, c = a.operation, d = a.error, f = a.extensions, g = c.key;
      if ("mutation" === c.operationName) {
        h(b, Q.get(g));
        Q.delete(g);
      } else {
        R(A.data, c.key);
      }
      if (a.data) {
        if (h(b, g = Ua(A, c, a.data, g).dependencies), g = ab(A, c, a.data), a.data = g.data, 
        "query" === c.operationName) {
          h(b, ta = g.dependencies);
        }
      } else {
        Fa(A.data, c.key);
      }
      ta && e(a.operation, ta);
      return {
        data: a.data,
        error: d,
        extensions: f,
        operation: c
      };
    }
    function d(a) {
      var b = ab(A, a), c = b.data ? b.partial ? "partial" : "hit" : "miss";
      e(a, b.dependencies);
      return {
        outcome: c,
        operation: a,
        data: b.data,
        dependencies: b.dependencies
      };
    }
    function e(a, b) {
      for (var c in b) {
        (ha[c] || (ha[c] = [])).push(a.key), ia.set(a.key, a);
      }
    }
    function f(a) {
      var b, c, d, e, f, k, fa;
      if ("query" === a.operationName) {
        R(A.data, a.key);
      } else if ("teardown" === a.operationName) {
        ia.delete(a.key), Fa(A.data, a.key);
      } else if ("mutation" === a.operationName && "network-only" !== a.context.requestPolicy) {
        b = Xa(A, a, a.key).dependencies;
        a: {
          for (c in b) {
            c = !1;
            break a;
          }
          c = !0;
        }
        if (!c) {
          for (d in b) {
            ja[d] = !0;
          }
          Q.set(a.key, b);
          h(d = new Set, b);
          g(a, d);
        }
      }
      b = _extends;
      if (a.variables) {
        if (d = B(a.query), (c = a.variables) && d.variableDefinitions) {
          for (e = {}, f = 0, k = d.variableDefinitions.length; f < k; f++) {
            e[fa = p(d.variableDefinitions[f].variable)] = c[fa];
          }
          d = e;
        } else {
          d = void 0;
        }
      } else {
        d = a.variables;
      }
      return b({}, a, {
        variables: d,
        query: formatDocument(a.query)
      });
    }
    function g(a, b) {
      b.forEach((function(b) {
        var c, d;
        if (b !== a.key) {
          if (c = ia.get(b)) {
            ia.delete(b);
            d = "cache-first";
            ua.has(b) && (ua.delete(b), d = "cache-and-network");
            P.reexecuteOperation(gb(c, d));
          }
        }
      }));
    }
    function h(a, b) {
      var c, d, e;
      if (b) {
        for (c in b) {
          if (b = ha[c]) {
            ha[c] = [];
            for (d = 0, e = b.length; d < e; d++) {
              a.add(b[d]);
            }
          }
        }
      }
    }
    function k(a) {
      for (var b in a) {
        if (ja[b]) {
          return !0;
        }
      }
      return !1;
    }
    function n(a) {
      "production" !== process.env.NODE_ENV && r({
        type: "cacheMiss",
        message: "The result could not be retrieved from the cache",
        operation: a.operation,
        source: "cacheExchange"
      });
      return fb(a.operation, "miss");
    }
    function m(a) {
      return "miss" === a.outcome && "cache-only" !== a.operation.context.requestPolicy && !k(a.dependencies);
    }
    function q(a) {
      var b = a.operation, c = a.outcome, d = a.dependencies, e = {
        operation: fb(b, c),
        data: a.data,
        error: a.error,
        extensions: a.extensions
      };
      if ("cache-and-network" === b.context.requestPolicy || "cache-first" === b.context.requestPolicy && "partial" === c) {
        e.stale = !0, k(d) ? "cache-and-network" === b.context.requestPolicy && ua.add(b.key) : P.reexecuteOperation(gb(b, "network-only"));
      }
      "production" !== process.env.NODE_ENV && r({
        type: "cacheHit",
        message: "A requested operation was found and returned from the cache.",
        operation: a.operation,
        data: {
          value: e
        },
        source: "cacheExchange"
      });
      return e;
    }
    function v(a) {
      var b = new Set, d = c(a, b);
      g(a.operation, b);
      return d;
    }
    function y(a) {
      return !Q.has(a.operation.key);
    }
    function D(a) {
      var b, d, e;
      if (ka.push(a) < Q.size) {
        return empty;
      }
      for (b = 0; b < ka.length; b++) {
        R(A.data, ka[b].operation.key);
      }
      for (d in ja) {
        delete ja[d];
      }
      b = [];
      d = new Set;
      for (;e = ka.shift(); ) {
        b.push(c(e, d));
      }
      g(a.operation, d);
      return fromArray(b);
    }
    function F(a) {
      return Q.has(a.operation.key);
    }
    var va, Q, ka, ia, ja, ua, ha, G = b.forward, P = b.client, r = b.dispatchDebug, A = new Y(a);
    a && a.storage && (va = a.storage.readData().then((function l(b) {
      var e, f, g, h, c = A.data, d = a.storage;
      O("read", c, null);
      for (e in b) {
        if (void 0 !== (f = b[e])) {
          h = (g = ya(e)).entityKey;
          g = g.fieldKey;
          ":" === f[0] ? Ma(h, g, JSON.parse(f.slice(1))) : W(h, g, JSON.parse(f));
        }
      }
      S();
      c.storage = d;
    })));
    Q = new Map, ka = [], ia = new Map, ja = J(), ua = new Set, ha = J();
    return function(a) {
      var b, c;
      a = share(a);
      b = va ? mergeMap(fromArray)(take(1)(buffer(fromPromise(va))(a))) : empty;
      b = share(concat([ b, a ]));
      a = share(map(d)(filter(hb)(b)));
      b = filter(ib)(b);
      c = map(n)(filter(m)(a));
      a = map(q)(filter(jb)(a));
      c = share(G(map(f)(merge([ b, c ]))));
      b = map(v)(filter(y)(c));
      c = mergeMap(D)(filter(F)(c));
      return merge([ b, c, a ]);
    };
  };
}

function lb(a) {
  return {
    query: print(a.query),
    variables: a.variables
  };
}

function offlineExchange(a) {
  return function(b) {
    function e(a) {
      var b, c, d, e, f;
      (b = "subscription" === a.operation.operationName) || (b = !((b = a.error) && b.networkError && !b.response && ("undefined" != typeof navigator && !1 === navigator.onLine || /request failed|failed to fetch|network\s?error/i.test(b.networkError.message))));
      if (b) {
        return !0;
      }
      if ("mutation" === a.operation.operationName) {
        a: {
          b = m;
          d = (c = a.operation).variables || J(), e = C(c.query);
          c = [].concat(t(B(c.query)));
          for (;f = c.pop(); ) {
            if (oa(f, d)) {
              if (f.kind !== Kind.FIELD) {
                (f = f.kind === Kind.INLINE_FRAGMENT ? f : e[p(f)]) && c.push.apply(c, t(f));
              } else if (b[p(f)]) {
                b = !0;
                break a;
              }
            }
          }
          b = !1;
        }
        return b ? (q.push(a.operation), v(), !1) : !0;
      }
      return !1;
    }
    var l, n, m, q, v, y, D, h = b.forward, k = b.client;
    b = b.dispatchDebug;
    n = h;
    if ((l = a.storage) && l.onOnline && l.readMetadata && l.writeMetadata) {
      m = a.optimistic || {}, q = [], v = function c() {
        l.writeMetadata(q.map(lb));
      }, y = !1;
      n = function f(a) {
        return filter(e)(h(a));
      };
      l.onOnline(D = function d() {
        for (var a; !y && (a = q.shift()); ) {
          y = !0, k.dispatchOperation(k.createRequestOperation("mutation", a)), y = !1;
        }
        v();
      });
      l.readMetadata().then((function g(a) {
        if (a) {
          for (var b = 0; b < a.length; b++) {
            q.push(createRequest(a[b].query, a[b].variables));
          }
        }
        D();
      }));
    }
    return kb(a)({
      forward: n,
      client: k,
      dispatchDebug: b
    });
  };
}

var da, u, za, K, L, M, N, Za;

import { print } from "graphql/language/printer";

import { share, mergeMap, fromArray, take, buffer, fromPromise, empty, concat, map, filter, merge } from "wonka";

import { buildClientSchema } from "graphql/utilities/buildClientSchema";

import { stringifyVariables, createRequest, formatDocument } from "@urql/core";

import { isNullableType, isNonNullType, isListType, GraphQLObjectType, GraphQLInterfaceType, GraphQLUnionType } from "graphql/type/definition";

import { Kind } from "graphql/language/kinds";

import { valueFromASTUntyped } from "graphql/utilities/valueFromASTUntyped";

import { _ as _extends } from "./5301ccd2.mjs";

da = new Set, u = [];

za = null, K = null, L = null, M = null, N = !1;

Za = /^__|PageInfo|(Connection|Edge)$/;

Y.prototype.keyOfEntity = function(a) {
  var e, b = a.__typename, c = a.id, d = a._id;
  if (!b) {
    return null;
  }
  if (void 0 !== this.rootNames[b]) {
    return b;
  }
  this.keys[b] ? e = this.keys[b](a) : null != c ? e = "" + c : null != d && (e = "" + d);
  return e ? b + ":" + e : null;
};

Y.prototype.resolveFieldByKey = function(a, b) {
  if (null === (a = null !== a && "string" != typeof a ? this.keyOfEntity(a) : a)) {
    return null;
  }
  var c = U(a, b);
  return void 0 !== c ? c : (b = V(a, b)) ? b : null;
};

Y.prototype.resolve = function(a, b, c) {
  return this.resolveFieldByKey(a, I(b, c));
};

Y.prototype.invalidate = function(a, b, c) {
  var e, d = "string" == typeof a ? a : this.keyOfEntity(a);
  x(d, "production" !== process.env.NODE_ENV ? "object" == "Can't generate a key for invalidate(...).\nYou have to pass an id or _id field or create a custom `keys` field for `" + typeof a ? a.__typename : a + "`." : "", 19);
  a = b ? [ {
    fieldKey: I(b, c)
  } ] : Qa(d);
  b = 0;
  for (c = a.length; b < c; b++) {
    void 0 !== V(d, e = a[b].fieldKey) ? Ma(d, e, void 0) : W(d, e, void 0);
  }
};

Y.prototype.inspectFields = function(a) {
  return null !== (a = null !== a && "string" != typeof a ? this.keyOfEntity(a) : a) ? Qa(a) : [];
};

Y.prototype.updateQuery = function(a, b) {
  a = createRequest(a.query, a.variables);
  null !== (b = b(this.readQuery(a))) && Va(this, a, b);
};

Y.prototype.readQuery = function(a) {
  return $a(this, createRequest(a.query, a.variables)).data;
};

Y.prototype.readFragment = function(a, b, c) {
  var d, e;
  if (void 0 === (d = (a = C(a))[(d = Object.keys(a))[0]])) {
    "production" !== process.env.NODE_ENV && z("readFragment(...) was called with an empty fragment.\nYou have to call it with at least one fragment in your GraphQL document.", 6), 
    c = null;
  } else {
    e = d.typeCondition.name.value;
    "string" == typeof b || b.__typename || (b.__typename = e);
    (b = "string" != typeof b ? this.keyOfEntity(_extends({}, {
      __typename: e
    }, b)) : b) ? ("production" !== process.env.NODE_ENV && w(e, d), c = Z(c = X(this, c || {}, a, e, b), b, t(d), {}) || null, 
    "production" !== process.env.NODE_ENV && u.pop()) : ("production" !== process.env.NODE_ENV && z("Can't generate a key for readFragment(...).\nYou have to pass an `id` or `_id` field or create a custom `keys` config for `" + e + "`.", 7), 
    c = null);
  }
  return c;
};

Y.prototype.writeFragment = function(a, b, c) {
  var d, e, f;
  if (void 0 === (d = (a = C(a))[(d = Object.keys(a))[0]])) {
    "production" !== process.env.NODE_ENV && z("writeFragment(...) was called with an empty fragment.\nYou have to call it with at least one fragment in your GraphQL document.", 11);
  } else {
    b = _extends({}, {
      __typename: e = d.typeCondition.name.value
    }, b);
    (f = this.keyOfEntity(b)) ? ("production" !== process.env.NODE_ENV && w(e, d), Wa(c = X(this, c || {}, a, e, f), f, t(d), b), 
    "production" !== process.env.NODE_ENV && u.pop()) : "production" !== process.env.NODE_ENV && z("Can't generate a key for writeFragment(...) data.\nYou have to pass an `id` or `_id` field or create a custom `keys` config for `" + e + "`.", 12);
  }
};

export { Y as Store, kb as cacheExchange, Fa as noopDataState, offlineExchange, ab as query, R as reserveLayer, Ua as write, Xa as writeOptimistic };
//# sourceMappingURL=urql-exchange-graphcache.mjs.map
